import StoryblokService from "@lib/storyblok/templates/storyblok-service.class";
class AssetsStoryblokService extends StoryblokService {
  constructor() {
    super();
    this.baseURL += "/assets";
  }
  async getPoweredByMuscleLogo() {
    return this.getSingleImage("".concat(this.baseURL, "/powered_by_logo"));
  }
  async getBenefitLogo() {
    return this.getSingleImage("".concat(this.baseURL, "/benefit_logo"));
  }
  async getCreditCardBrandLogo(creditCardBrand) {
    const baseURL = "".concat(this.baseURL, "/credit_card_providers");
    switch (creditCardBrand) {
      case 'MASTERCARD':
        return this.getSingleImage("".concat(baseURL, "/mastercard_logo"));
      case 'VISA':
        return this.getSingleImage("".concat(baseURL, "/visa_logo"));
      case 'AMERICAN_EXPRESS':
        return this.getSingleImage("".concat(baseURL, "/amex_logo"));
      case 'DINERS_CLUB':
        return this.getSingleImage("".concat(baseURL, "/diners_club_logo"));
      case 'ALL':
        return this.getSingleImage("".concat(baseURL, "/all"));
      default:
        return null;
    }
  }
  async getErrorImage(errorCode) {
    return this.getSingleImage("".concat(this.baseURL, "/error-images/").concat(errorCode));
  }
  async getExploreByMuscleFullWhiteLogo() {
    return this.getSingleImage("".concat(this.baseURL, "/imagotype_full_white"));
  }
}
const assetsStotyblokService = new AssetsStoryblokService();
export default assetsStotyblokService;